import React, {useRef, useState} from "react";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';

import {Card} from "../global/Card";

export const TabsSection = (props) => {

  const {tabsData} = props;
  const [currentSlide, setCurrentSlide] = useState(0);
  const tabsRef = useRef([]);

  const scrollToActive = () => {
    tabsRef.current
      .find(el => el.classList.contains('active'))
      .scrollIntoView({behavior: "smooth", block: 'start', inline: "center"});
  }

  const nextSlide = () => {
    if (currentSlide < tabsData.length - 1) {
      setCurrentSlide(currentSlide + 1)
      scrollToActive();
    }
  }

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1)
      scrollToActive();
    }
  }

  const renderTabsHeadings = () => {
    return tabsData.map((tab, index) => {
      return (
        <Nav.Item key={index}>
          <Nav.Link className="zg-tab" eventKey={index} ref={(el) => (tabsRef.current[index] = el)}>
            <span className="zg-tab__title subtitle">
              <img width={24} height={24} className="me-2" src={tab.icon.localFile.publicURL} alt={tab.title}/>
              {tab.title}
            </span>
            <span className="zg-tab__label">0{index + 1}</span>
          </Nav.Link>
        </Nav.Item>
      )
    })
  }

  const renderTabsContent = () => {
    return tabsData.map((tabContent, index) => {
      return (
        <Tab.Pane
          key={index}
          eventKey={index}>
          <Card
            text={tabContent.text}
            image={tabContent.image.localFile.publicURL}
            button={tabContent.link}
            classes="zg-card-image-r zg-tab-card height-100"
          />
        </Tab.Pane>
      )
    })
  }

  return (
    <section className="py-lg-12 py-md-11 py-7 overflow-hidden">
      <div className="container">
        <Tab.Container
          id="tabs"
          defaultActiveKey='0'
          activeKey={currentSlide}
          onSelect={(activeKey) => {
            setCurrentSlide(parseInt(activeKey))
          }}>
          <div className="row">
            <div className="col-lg-5 col-sm-12">
              <Nav variant="pills" className="flex-lg-column mb-lg-0 mb-8 zg-tabs">
                {renderTabsHeadings()}
              </Nav>
            </div>
            <div className="col-lg-7 col-sm-12">
              <Tab.Content>
                {renderTabsContent()}
              </Tab.Content>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="d-flex d-lg-none splide__arrows">
                <button className="btn splide__arrow splide__arrow--prev"
                        disabled={currentSlide === 0 ?? true}
                        onClick={prevSlide}>
                  <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
                    <path d="M25 12L1 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M8 19L1 12L8 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                          strokeLinejoin="round"/>
                  </svg>
                </button>
                <div className="d-inline-flex align-items-center">
                  <span className="splide__current">{currentSlide + 1}</span>
                  <span className="splide__total">{tabsData.length}</span>
                </div>
                <button className="btn splide__arrow splide__arrow--next"
                        disabled={currentSlide === tabsData.length - 1 ?? true}
                        onClick={nextSlide}>
                  <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
                    <path d="M1 12L25 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M18 19L25 12L18 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                          strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </Tab.Container>
      </div>
    </section>
  )
}
